import { tradeRewardsLevelUpModalRule } from './tradeRewardsLevelUpModalRule';
import { tradeRewardsLevelUpModalAction } from './tradeRewardsLevelUpModalAction';

export default {
    name: 'tradeRewardsLevelUp',
    priority: 448,
    rule: tradeRewardsLevelUpModalRule,
    action: tradeRewardsLevelUpModalAction,
};
